// src/api/apiHotels.js
import axios from "../utils/axios";

/// Get Hotels
export const getAllHotels = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("hotels", { params });
    return data;
};

/// Get Hotel
export const getHotel = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`hotels/${id}`);
    return data;
};

/// Create Hotel
export const createHotel = async (req) => {
    try {
        const { data } = await axios.post("hotels", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createHotel error:", error);
        throw error;
    }
};

/// Update Hotel
export const updateHotel = async (id, req) => {
    try {
        const { data } = await axios.put(`hotels/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateHotel error:", error);
        throw error;
    }
};

/// Delete Hotel
export const deleteHotel = async (id) => {
    try {
        const { data } = await axios.delete(`hotels/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteHotel error:", error);
        throw error;
    }
};

/// Delete All Hotels
export const deleteAllHotels = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotels/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllHotels error:", error);
        throw error;
    }
};

/// Restore Hotel
export const restoreHotel = async (id) => {
    try {
        const { data } = await axios.post(`hotels/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreHotel error:", error);
        throw error;
    }
};

/// Restore multiple Hotels
export const restoreAllHotels = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "hotels/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllHotels error:", error);
        throw error;
    }
};

/// Force Delete Hotel
export const forceDeleteHotel = async (id) => {
    try {
        const { data } = await axios.delete(`hotels/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteHotel error:", error);
        throw error;
    }
};

/// Force Delete multiple Hotels
export const forceDeleteAllHotels = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "hotels/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllHotels error:", error);
        throw error;
    }
};

/// Get Hotels For Select
export const getHotelsForSelect = async (filters = {}) => {
    try {
        const { data } = await axios.get("hotels/for-select", { params: filters });
        return data;
    } catch (error) {
        console.error("getHotelsForSelect error:", error);
        throw error;
    }
};
